<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="role-n" class="form-label">Name *</label>
              <input type="text" class="form-control" id="role-n" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="role-code" class="form-label">Code</label>
              <input type="text" class="form-control" id="role-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="cur-name" class="form-label">Description</label>
              <input type="text" class="form-control" id="cur-name" v-model="entity.description"/>
            </div>
            <div class="form-group">
              <label for="acc-codes" class="form-label">Access codes</label>
              <input type="text" class="form-control" id="acc-codes" v-model="entity.accessCodes"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="masterrole" class="form-label">Master role</label>
              <select class="form-control" id="masterrole" v-model="entity.masterRole">
                <option value=""></option>
                <option v-for="(opt, i) in roles" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="location-comments" class="form-label">Comments</label>
              <textarea class="form-control" rows="5" id="location-comments" v-model="entity.notes"></textarea>
            </div>
            <div class="form-group" v-for="p in permissions" :key="p.code">
              <label :for="p.code" class="form-label">{{ p.label }}</label>
              <input style="display: block" :id="p.code" type="checkbox" :value="p.code" v-model="selectedPermissions"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'Role',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'roles',
        transformForUpdate: {
          masterRole: this.toMinus
        },
        newEntityScreen: 'Admin - Roles',
        editEntityScreen: 'Admin - Edit/View Role',
        tab: 'main',
        entity: {
          id: null,
          code: null,
          name: null,
          description: null,
          masterRole: null,
          notes: null,
          accessCodes: null
        },
        entityName: 'role',
        boxes: [
          {
            prop: 'masterRole',
            id: 'id'
          }
        ],
        permissions: [
          { code: 'SETUP', label: 'Setup' },
          { code: 'PARTY', label: 'Parties' },
          { code: 'FINANCE', label: 'Finance' },
          { code: 'ROUTE', label: 'Routing' },
          { code: 'TARIFF', label: 'Tariffs' },
          { code: 'REPORT', label: 'Reports' },
          { code: 'QUOTE', label: 'Quotes' },
          { code: 'RFP', label: 'Request For Proposal' }
        ],
        selectedPermissions: []
      }
    },
    computed: {
      isValid () {
        return this.entity.name && this.entity.name.trim().length
      },
      roles () {
        return this.$store.getters['systemOption/roles']
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          description: null,
          masterRole: null,
          notes: null,
          accessCodes: null
        }
      },
      preSaveRoutine () {
        return new Promise((resolve, reject) => {
          this.entity.accessCodes = this.selectedPermissions.join(',')
          this.$nextTick(resolve)
        })
      },
      refresh () {
        this.selectedPermissions = this.entity.accessCodes ? this.entity.accessCodes.split(',') : []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// Role.vue?77ff78f4